<template>
    <div class="topdiv">
        <p class="main_title">账号信息</p>
        <div>
            <UserInfo />
        </div>
        <br />
        <p class="main_title">订购记录</p>
        <Table class="mytableframe" :row-class-name="rowClassName" :no-data-text="nodatatxt"  :columns="columns1" :data="data1" :height="table_height">
            <template slot-scope="{ row}" slot="productname">
                <strong>{{row.productname}}</strong>
            </template>
            <template slot-scope="{ row }" slot="starttime">
                <strong>{{row.starttime}}</strong>
            </template>
            <template slot-scope="{ row }" slot="endtime">
                <strong>{{row.endtime}}</strong>
            </template>
            <template slot-scope="{ row,index }" slot="action">
                <div v-if="sta.accounttype===2 || sta.accounttype===3 || sta.accounttype===5"></div>
                <div v-else>
                    <div v-if="sta.mallver==='v2'">
                        <div v-if="data1.length>0&&index===0">
                            <Button type="primary" size="small" style="width: 120px;" @click="goStoreV2">续费</Button>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="data1.length>0&&index===0">
                            <div v-if="!row.isexpire">
                                <div>
                                    <Button type="success" size="small" @click="showRenewalModal(row)">续费</Button>
                                    <Button v-if="row.isusing" style="margin-left:2px;" type="success" size="small" @click="showRenewalVIPModal(row)">购买VIP</Button>
                                    <Button v-else style="margin-left:2px;" type="success" size="small" @click="showRenewalVIPModal(row)">续购VIP</Button>
                                </div>
                            </div>
                            <div v-else>
                                已过期
                            </div>
                        </div>
                        <div v-else-if="data1.length>0&&index!==0">
                            <div v-if="!row.isexpire">
                                <Button v-if="row.isusing" style="margin-left:2px;" type="success" size="small" @click="showRenewalVIPModal(row)">购买VIP</Button>
                                <Button v-else style="margin-left:2px;" type="success" size="small" @click="showRenewalVIPModal(row)">续购VIP</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Table>
        <div v-if="sta.mallver==='v2'">
        </div>
        <div v-else>
            <p slot="title" class="classtitle"><i class="iconfont">&#xe876;</i> VIP升级权限</p>
            <div class="setheader">
                <Table :row-class-name="rowClassName" :columns="columns2" :data="data2" height="200">
                    <template slot-scope="{ row }" slot="starttime">
                        <strong>{{row.starttime}}</strong>
                    </template>
                </Table>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import UserInfo from '../../components/userlogin/userinfo.vue'
import eventBus from "../../components/common/event_bus.js"
import moment from 'moment'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            nodatatxt:"<img src='/resource/images/nodata.png' style='height:\'98px;\' width=\'66px;\'' />",
            expirationTime: '',
            columns1: [{
                    type: 'index',
                    width: 60,
                    align: 'center'
                }, {
                    title: '产品名称',
                    slot: 'productname',
                },
                {
                    title: '开始时间',
                    slot: 'starttime'
                },
                {
                    title: '到期时间',
                    slot: 'endtime'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 200,
                    align: 'center'
                }
            ],
            data1: [],
            columns2: [{
                    type: 'index',
                    width: 60,
                    align: 'center'
                }, {
                    title: '功能名称',
                    key: 'func_name'
                },
                {
                    title: '购买数量',
                    key: 'func_number'
                },
                {
                    title: '开始时间',
                    slot: 'starttime'
                },
                {
                    title: '到期时间',
                    key: 'endtime'
                }
            ],
            data2: [],
            table_height:490,
        }
    },
    methods: {
        goStoreV2() {
            this.$router.push({ name: 'userstore' })
            return
        },
        checkUserLogin() {
            let value = this.getUserId
            console.log(value)
            if (value && value.length > 0) {
                return true
            } else {
                return false
            }
        },
        showRenewalModal(row) {
            console.log(row)
            if (row.ordertype === 101) {
                this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
                return
            }
            eventBus.$emit("user-renewal", row) //go renewal
        },
        showRenewalVIPModal(row) {
            eventBus.$emit("user-vip-renewal", row) //go renewal
        },
        rowClassName(row, index) {
            if (index % 2 == 1) {
                return 'text-table-info-row';
            }
            return '';
        },
        show() {
            //测试团购非自用，团购非自用不能续费账号等级，可以购买当前在售账号等级
            // store.state.user.accounttype=4
            // console.log(this.sta.accounttype)
            //获取已购产品
            constJ.reqGetUserProduct().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.items) {
                        this.data1 = res.items
                    } else {
                        //items返回null
                        this.data1 = []
                    }

                }
            })

            //this.data1 = store.state.user.myvippackage
            //console.log(this.data1)

            //获取已购产品扩展包
            constJ.reqGetUserPackage().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.items) {
                        this.data2 = res.items
                    } else {
                        //items返回null
                        this.data2 = []
                    }

                }
            })

            // this.data1 = store.state.user.myvippackage;
            // this.data2 = store.state.user.myextentionpackage
        },
    },
    mounted() {
        eventBus.$on('myproducts-reload', () => {
            console.log("go myproducts-reload...")
            if (this.checkUserLogin()) {
                this.show()
            }

        })
    },
    beforeDestroy() {
        console.log('remove eventBus')
        eventBus.$off('myproducts-reload')
        //document.removeEventListener('click', this.myFunc)
    },
    components: {
        'UserInfo': UserInfo,
    },
    computed: {
        ...mapGetters(['getUserId', 'sta'])
    },
    created() {
        //console.log('my product..')
        if (this.checkUserLogin()) {
            this.show()
        }
        // let a = document.getElementsByClassName('main-right')[0]
        // this.table_height = a.clientHeight - 50
        // this.data1 = []
        // this.data2 = []
        // this.data1 = store.state.user.myvippackage
        // this.data2 = store.state.user.myextentionpackage
        //this.expirationTime = moment().add(365, 'days').format("YYYY-MM-DD");
    }
}
</script>
<style lang="less" scoped>
@font-face {
    font-family: 'iconfont';
    /* project id 2108466 */
    src: url('//at.alicdn.com/t/font_2108466_tzihg2kjyc.eot');
    src: url('//at.alicdn.com/t/font_2108466_tzihg2kjyc.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_2108466_tzihg2kjyc.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_2108466_tzihg2kjyc.woff') format('woff'),
        url('//at.alicdn.com/t/font_2108466_tzihg2kjyc.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_2108466_tzihg2kjyc.svg#iconfont') format('svg');
}

.iconfont {
    color: #ff9900;
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
}


.ivu-table .text-table-info-row td {
    background-color: #fffcf8;
    /* color: #515a6e; */
}

.classtitle {
    font-size: 14px;
    background-color: #fff;
    height: 50px;
    line-height: 50px;
    vertical-align: middle;
    padding-left: 10px;
}


.mytableframe/deep/tr {
    height: 50px;
}
.topdiv {
    background: #fff;
    padding: 5px;
    width: 98%;
    margin: 0 auto;
}

.main_title {
    height: 20px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #2D2F33;
    margin-bottom: 30px;
    padding-left: 10px;
}


</style>